<div [ngClass]="['grid gap-3 md:gap-4', gridClass()]">
  @for (card of cards; track $index) {
    <div
      class="group relative bg-white rounded-lg shadow-sm border border-gray-200 p-3 md:p-3.5 hover:border-[#6729FF]/20 transition-all duration-300 overflow-hidden"
    >
      <!-- Decorative gradient background -->
      <div
        class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#6729FF]/5 to-transparent rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      ></div>

      <div class="z-10">
        <!-- Vertical accent line on the left -->
        <div
          class="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#6729FF] to-transparent rounded-full transition-all duration-300"
        ></div>

        <!-- Content padding to avoid overlap -->
        <div class="pl-2.5">
          <!-- Title -->
          <p class="text-[10px] md:text-xs text-gray-500 tracking-wide font-medium mb-1.5">
            {{ card.title }}
          </p>

          <!-- Value display -->
          <p class="text-lg md:text-xl font-semibold text-gray-900 tracking-tight">
            {{ formatValue(card.value, card.currency) }}
          </p>
        </div>
      </div>
    </div>
  }
</div>

